import { render, staticRenderFns } from "./gestion-cambio-editar.vue?vue&type=template&id=629551a0&scoped=true&"
import script from "./gestion-cambio-editar.vue?vue&type=script&lang=js&"
export * from "./gestion-cambio-editar.vue?vue&type=script&lang=js&"
import style0 from "./gestion-cambio-editar.vue?vue&type=style&index=0&id=629551a0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "629551a0",
  null
  
)

export default component.exports